import React from 'react';
// DashboardLayout is applied by the router, no need to import here.
import MetricCard from '../../components/ui/MetricCard'; // Import MetricCard
import InfoCard from '../../components/ui/InfoCard'; // Import InfoCard
import CheckinStep from '../../components/ui/CheckinStep'; // Import CheckinStep
// CompletedStepIcon and PendingStepIcon are used internally by CheckinStep, no need to import here.

const SealSupplierScreen = () => {
    // Placeholder data for supplier seal steps, similar to HomeSupplierScreen
    const sealSteps = [
        { id: 1, text: "Registro completo", status: "completed" },
        { id: 2, text: "Completar formulario Sello Checkin", status: "pending" },
        // Add more seal-specific steps here
    ];
    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-4">¡Bienvenido/a!</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <button type="button" className="btn btn-success d-flex align-items-center">
                        Descargar Manual Checkin
                    </button>
                </div>
            </div>

            <div className="row text-center mb-4">
                <MetricCard value="1" text="Reserva Concretada" />
                <MetricCard value="3" text="Servicios Publicados" />
            </div>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h3 className="mb-4">Tus servicios más reservados</h3>
            </div>

            {/* TODO: Replace with dynamic data */}
            <div className="row mb-5 justify-content-start">
                <InfoCard
                    imageUrl="https://placehold.co/600x400/EFEFEF/AAAAAA&text=Placeholder"
                    imageAlt="Habitación Simple"
                    title="Habitación Simple"
                    linkTo="#" // Replace with actual link
                />
                <InfoCard
                    imageUrl="https://placehold.co/600x400/EFEFEF/AAAAAA&text=Placeholder"
                    imageAlt="Habitación Doble"
                    title="Habitación Doble"
                    linkTo="#" // Replace with actual link
                />
                <InfoCard
                    imageUrl="https://placehold.co/600x400/EFEFEF/AAAAAA&text=Placeholder"
                    imageAlt="Masaje con piedras"
                    title="Masaje con piedras"
                    linkTo="#" // Replace with actual link
                />
                <InfoCard
                    imageUrl="https://placehold.co/600x400/EFEFEF/AAAAAA&text=Placeholder"
                    imageAlt="Otro Masaje con piedras"
                    title="Masaje con piedras"
                    linkTo="#" // Replace with actual link
                />
            </div>

            <h3 className="mb-3">Tu ruta como proveedor</h3>
            <p className="mb-4 text-muted">Tu información paso a paso</p>

            <div className="list-group gap-3">
                {sealSteps.map(step => (
                    <CheckinStep
                        key={step.id}
                        text={step.text}
                        status={step.status}
                    />
                ))}
            </div>
        </>
    );
};

export default SealSupplierScreen;